import {formatMoney} from '@shopify/theme-currency';
import * as cart from '@shopify/theme-cart';

export default function init ({ el, context }) {

	let lastScrollPos = 0;

	let productForm = document.querySelector('.product-container__main')

	let stickyForm = el.querySelector('form')
	var idElement = stickyForm.querySelector('[name="id"]')
  var quantity = 1
  var properties = {

  }

	stickyForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    let id = parseInt(idElement.value)
    let productResult = await addProductToCart(id, quantity, properties)
    document.dispatchEvent(new Event('addedToCart'));
  });

  const addProductToCart = async (id, quantity, properties) => {
    return await cart.addItem(id, { quantity, properties })
  }

  let stickFormClose = el.querySelector('[data-mobile-sticky-form-close]')
  stickFormClose.addEventListener('click', async (e) => {
    e.preventDefault();
    el.style.display = 'none'
  });

  const processScroll = () => {
  	var scrollY = window.scrollY || window.pageYOffset;
    let documentHeight = document.body.offsetHeight - window.innerHeight;
    let footerHeight = document.querySelector('#shopify-section-footer').offsetHeight;

  	if ( scrollY > productForm.offsetHeight && scrollY < (documentHeight - footerHeight) ) {
  		el.classList.add('visible')
    } else {
      el.classList.remove('visible')
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    processScroll()
  })
  window.addEventListener('resize', () => {
    processScroll()
  })
  window.addEventListener('scroll', () => {
    processScroll()
  })
}